import * as React from "react";
import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import "./../../resources/forest.jpg";

import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import {ExerciseTask, TaskOption, Exercise} from '../server/ExamServer'
import ExamTask from "./ExamTask";



const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});

export interface ExamExerciseProps {
    exercise:Exercise
    onSelect:(option: TaskOption, task:ExerciseTask, exercise: Exercise) => void
}

export interface ExamExerciseState {

}


class ExamExercise extends React.Component<ExamExerciseProps, ExamExerciseState> {


    constructor(props: ExamExerciseProps) {
        super(props);
    }

    handleSelect = (option: TaskOption, task:ExerciseTask) => {
        this.props.onSelect && this.props.onSelect(option, task, this.props.exercise);
    }
    

    render() {

        const {exercise} = this.props
        return (
            <div style={{margin:theme.spacing(3), marginTop:theme.spacing(5)}}>


                <Typography variant="subtitle2" color="initial" component="h5">
                    {exercise.name}
                </Typography>

                <Typography variant="subtitle1" color="textPrimary" component="h5">
                    {exercise.description}
                </Typography>


                {exercise.tasks.map((task, i) =>{
                    return <ExamTask index={i} type={exercise.type} task={task} onSelect={this.handleSelect} />
                })}
            </div>

        );
    }
}

export default ExamExercise;
